import { FC, ReactNode } from "react";

/* Languages bundled by highlight.js/lib/common (typical v11.x set)
   Exact list can vary slightly by hljs version. */

type CodeSnippetBlockProps = {
  slot: ReactNode;
};

export const CodeSnippetBlock: FC<CodeSnippetBlockProps> = ({ slot }) => slot;
